export const hoursOfServiceRecord = (name?: string, license?: any, date?: string) => {
  return [
    { text: 'Hours Of Service Record For First or Intermittent Drivers', style: 'h1' },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 250,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 270,
          y1: 0,
          x2: 500,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },
    { text: `${name}`, margin: [0,-20, 0, 0] },
    { text: "Name (Print)", style: 'label', margin: [0,2,0,0]},
    { text: `${license.license}`, margin: [270,-28, 0, 0] },
    { text: "Motor Vehicle Operator’s License Number", style: 'label', margin: [270,2,0,0]},

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 10,
          x2: 250,
          y2: 10,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 270,
          y1: 10,
          x2: 500,
          y2: 10,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },
    { text: `${license.type}`, margin: [0,-20, 0, 0] },
    { text: "Type of License", style: 'label', margin: [0,2,0,0]},
    { text: `${license.state}`, margin: [270,-28, 0, 0] },
    { text: "Issuing State", style: 'label', margin: [270,2,0,0]},

    { text: 'Instructions: Motor carriers when using a driver for the first time or intermittently shall obtain from the driver a signed statement driving the total time on duty during the immediately preceding seven (7) days and time at which such driver was last relieved from duty to beginning work from such carrier. Rule 395.8(j)(2).', style: 'p', margin: [0, 15, 0, 0] },

    {
      table: {
        widths: [75, 75, 75],
        body: [
          [
            { text: 'DATE', style: 'tableHeader', alignment: 'center' },
            { text: 'DAY', style: 'tableHeader', alignment: 'center' },
            { text: 'HOURS WORKED', style: 'tableHeader', alignment: 'center' },
          ],
          ...[1, 2, 3, 4, 5, 6, 7, 8].map(day => ([
            { text: '', style: 'tableCell', fillColor: '#ffffff' },
            { text: String(day), style: 'tableCell', alignment: 'center' },
            { text: '', style: 'tableCell', fillColor: '#ffffff' },
          ])),
          [
            { text: '', style: 'tableCell' },
            {
              text: 'TOTAL HOURS:',
              style: 'tableHeader',
              alignment: 'left',
              colSpan: 2,
            },
            {},
          ]
        ]
      },
      layout: {
        hLineWidth: () => 1,
        vLineWidth: () => 1,
        hLineColor: () => 'black',
        vLineColor: () => 'black',
      },
      margin: [0, 20, 0, 20]
    },

    { text: 'I hereby certify that the information given above is correct to the best of my knowledge and belief, and that I was relieved from work at _____________ (Time) on _____________' +
        ' (Month/Day/Year).', style: 'p', margin: [0, 10, 0, 20] },

    { canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 340,
          y1: 0,
          x2: 490,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: `${name}`, margin: [0,-22, 0, 0]},
    { text: "Driver's Name", style: 'label', margin: [0,5,0,0]},
    { text: "Driver's Signature", style: 'label', margin: [170,-12,0,0]},
    { text: `${date}`, margin: [340,-32, 0, 0]},
    { text: "Date", style: 'label', margin: [340,5,0,0] },

    { text: 'This form is to be completed on the day before or day of the driver’s first dispatch.', style: 'p', margin: [0, 20, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};